module.exports = __webpack_public_path__ + "static/img/3.1ad76d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/3.png
// module id = MsM8
// module chunks = 0